// extracted by mini-css-extract-plugin
module.exports = {"green":"#46ff87","yellow":"#fff95a","magenta":"#ff8eec","cyan":"#5effde","violet":"#6b8fed","black":"black","white":"white","red":"red"};